import React from 'react';
import {
  Button,
  Form,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalSection,
  Textarea,
} from '@axiom/ui';
import type { Account, User } from '@axiom/validation';

import { postDigitalBenchAskUsHow } from '../../api/hubspot-api';

import type { MyBenchAskHowModalType } from './my-bench-ask-how-modal-schema';
import { MyBenchAskHowModalSchema } from './my-bench-ask-how-modal-schema';

export type MyBenchAskHowModalProps = {
  account: Account;
  user: User;
  onClose: () => void;
};

export const MyBenchAskHowModal = ({
  account,
  user,
  onClose,
}: MyBenchAskHowModalProps) => {
  const handleOnSubmit = async (
    changeData: Partial<MyBenchAskHowModalType>
  ) => {
    const payload = {
      fields: [
        { name: 'firstname', value: user.firstName },
        { name: 'lastname', value: user.lastName },
        {
          name: 'email',
          value: user.email,
        },
        {
          name: 'axiom_for_clients_account_display_name',
          value: account.calculatedName,
        },
        { name: 'description', value: changeData.description || '' },
      ],
    };

    await postDigitalBenchAskUsHow(payload);
    onClose();
  };

  return (
    <Form
      name="ASK_HOW_MODAL_FORM"
      schema={MyBenchAskHowModalSchema}
      initialValues={{ description: '' }}
      onSubmit={handleOnSubmit}
    >
      {({ fireSubmit }) => (
        <Modal name="ASK_HOW_MODAL">
          <ModalHeader
            name="MODAL_HEADER"
            onClose={() => {
              onClose();
            }}
          >
            Ask us how to build your Axiom bench
          </ModalHeader>
          <ModalSection>
            <Textarea
              name="description"
              label="Add a message"
              description="Anything else we should know about your current legal needs to better suggest the right talent for you?"
              full
            />
          </ModalSection>
          <ModalFooter>
            <Button
              variation="outline"
              name="CANCEL"
              onClick={() => {
                onClose();
              }}
            >
              Close
            </Button>
            <Button
              name="SUBMIT"
              onClick={async () => {
                await fireSubmit();
              }}
            >
              Submit
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </Form>
  );
};
